import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Hero from '../../static/img/events_page/yes_hero.png';
import Img1 from '../../static/img/events_page/yes_img1.png';
import Img2 from '../../static/img/events_page/yes_img2.png';

const styles = theme => ({
  bottomMargin: {
    marginBottom: theme.spacing(3),
  },
  centeredText: {
    textAlign: 'center',
  },
});

function description(props) {
  const { classes } = props;
  return (
    <div className={classes.bottomMargin}>
      <Typography className={classes.bottomMargin} variant="body1">It is human nature to be attracted, drawn, nand pulled toward things. The pull we sense is physical, mental, emotional and spiritual messaging. How we respond to the pull depends upon education, choice and consciousness.</Typography>
      <Typography className={classes.bottomMargin} variant="body1">This workshop will guide you in making conscious choices while you navigate these strong forces. Along the way, you will learn my 30-Second Body First Game and become familiar with the guiding language and function of each Chakra.</Typography>
    </div>
  );
}

function paymentPolicy(props) {
  const { classes } = props;
  return (
    <div>
      <Typography className={classes.bottomMargin} variant="body1">The price of the Nia Black Belt Training is $1,599 (USD) plus tax where applicable. The fee for the training is split into two payments, a Registration Fee and an Instruction Fee. To reserve your spot in a training, you must pay a Registration Fee directly to Nia Technique, Inc. (via NiaNow&apos;s online registration system). The Trainer of your event will invoice you for the Instruction Fee and any applicable tax 30 days prior to the training start date. Based on the location of the event, the Trainer may invoice you in local currency at the current exchange rate with the USD.</Typography>
      <Typography className={classes.bottomMargin} variant="body1">All trainings will be confirmed 30 days prior to the event start date. Nia Technique recommends all customers wait to purchase any travel or accommodations until the event has been confirmed. </Typography>
    </div>
  );
}

function cancellationPolicy(props) {
  const { classes } = props;
  return (
    <div className={classes.bottomMargin}>
      <Typography className={classes.bottomMargin} variant="body1">Registration and instruction fees are non-refundable. Should you cancel your registration more than 30 days prior to the training start date, the registration fee will be credited to your Nia account. Should you cancel your registration less than 30 days prior to the training start date, you will incur a cancellation fee of $250 which will be deducted from your registration fee. The remaining balance will be credited to your Nia account.</Typography>
      <Typography className={classes.bottomMargin} variant="body1">The cancellation policy regarding your instruction fee varies by trainer. Please contact your trainer for more information.</Typography>
      <Typography className={classes.quoteAuthor} variant="body1">If you have paid for a training that is canceled by the trainer, you will receive a full refund.</Typography>
    </div>
  );
}


description.propTypes = {
  classes: PropTypes.object.isRequired,
};
paymentPolicy.propTypes = {
  classes: PropTypes.object.isRequired,
};
cancellationPolicy.propTypes = {
  classes: PropTypes.object.isRequired,
};

const Description = withStyles(styles)(description);
const PaymentPolicy = withStyles(styles)(paymentPolicy);
const CancellationPolicy = withStyles(styles)(cancellationPolicy);

const Event = {
  title: 'Dance Yes',
  quote: 'Within all of us is a divine capacity to manifest and attract all that we need and desire.',
  quoteAuthor: '– Wayne Dyer',
  price: '$300 USD',
  eligibility: 'All Students Welcome',
  button: 'Find a Workshop',
  hero: Hero,
  img1: Img1,
  img2: Img2,
  description: <Description />,
  paymentPolicy: <PaymentPolicy />,
  cancellationPolicy: <CancellationPolicy />,
};

export default Event;
